export default __webpack_public_path__ + "static/media/CV_rewardUnlock.a9256c14.png";